// Search Form
$( ".filter-section .filter .item" ).each(function(index) {
    $(this).on("click", function(){
        $( this ).toggleClass( "selected appear disappear" );
    });
});

// select all
$( ".filter-section .filter .select-toggle .select" ).each(function(index) {
    $(this).on("click", function(){
        $(this).closest(".card-body").find('.grid-wrapper').find('.item').each(function(index) {
            $( this ).removeClass("disappear");
            $( this ).addClass("selected appear");
        });
        filterByTerms();
    });
});

// unselect all
$( ".filter-section .filter .select-toggle .unselect" ).each(function(index) {
    $(this).on("click", function(){
        $(this).closest(".card-body").find('.grid-wrapper').find('.item').each(function(index) {
            $( this ).removeClass("selected appear");
            $( this ).addClass("disappear");
        });
        filterByTerms();
    });
});

// legend
$( ".capci-database .legend").on("click", function(){
    $( this ).toggleClass( "selected" );
});

$('.capci-database #search-order').on('change', function() {
    fillInputs();
    $('form.filter button').click();
});

function getTerms(containerID) {
    let terms = [];
    if ($( containerID + ' .item' ).length < 1) {
        return [];
    }
    $( containerID + ' .item' ).each(function(index, item) {
        if ($(item).hasClass('appear')) {
            terms.push($(item).attr('data-term-id').replace('lf-', '').replace(' ', '').toLowerCase());
        }
    });
    return terms;
}

// show or hide results, based on selected items
function filterByTerms() {
    let status = getTerms('.filter #collapse1-3');
    let cycle = getTerms('.filter #collapse1-2');
    let keys = getTerms('.filter #collapse1-1');

    $('.capci-database .results').each(function(i, el) {
        let hitStatus = false;
        let hitCycle = false;
        let hitKey = false;

        let elStatus = $(el).attr('data-status').replace(' ', '').toLowerCase();
        let elCycle = $(el).attr('data-life-cycle').replace('lf-', '').replace(' ', '').toLowerCase();
        let elKeys = $(el).attr('data-identification-keys');
        elKeys = elKeys.split(' ');

        if ($('.filter #collapse1-3').length < 1) {
            hitStatus = true;
        } else {
            if (elStatus === 'underdevelopement') {
                elStatus = 'underdevelopment';
            }
            if (status.filter(x => x === elStatus).length > 0) {
                hitStatus = true;
            }
        }

        if ($('.filter #collapse1-2').length < 1) {
            hitCycle = true;
        } else {
            if (cycle.filter(x => x === elCycle).length > 0) {
                hitCycle = true;
            }
        }

        $(elKeys).each(function(index, item) {
            if (item !== '') {
                item = item.replace(' ', '').toLowerCase();
                if (keys.filter(x => x === item).length > 0) {
                    hitKey = true;
                }
            }
        });

        if (hitKey) {
            $(el).show();
            $(el).removeAttr('style');

            if (hitStatus && hitCycle) {
                $(el).show();
                $(el).removeAttr('style');
            } else {
                $(el).hide();
            }
        } else {
            $(el).hide();
        }
    });
}

if ($( '.filter #collapse1-1' ).length > 0) {
    $('.filter #collapse1-1 .item').on('click', function (item) {
        filterByTerms();
    });
}

if ($( '.filter #collapse1-2' ).length > 0) {
    $('.filter #collapse1-2 .item').on('click', function (item) {
        filterByTerms();
    });
}

if ($( '.filter #collapse1-3' ).length > 0) {
    $('.filter #collapse1-3 .item').on('click', function (item) {
        filterByTerms();
    });
}

function fillInputs() {
    let identification_keys = [];
    let life_cycles = [];
    let status = [];

    $( '#collapse1-1 .item' ).each(function(index, item) {
        if ($(item).hasClass('appear')) {
            identification_keys.push($(item).attr('data-term-id').replace(' ', ''));
        }
    });

    if ($( '#collapse1-2' ).length > 0) {
        $('#collapse1-2 .item').each(function (index, item) {
            if ($(item).hasClass('appear')) {
                life_cycles.push($(item).attr('data-term-id').replace('lf-', '').replace(' ', ''));
            }
        });
    }

    if ($( '#collapse1-3' ).length > 0) {
        $('#collapse1-3 .item').each(function (index, item) {
            if ($(item).hasClass('appear')) {
                status.push($(item).attr('data-term-id'));
            }
        });
    }

    $('#form_status').val(status.join(','));
    $('#form_life_cycles').val(life_cycles.join(','));
    $('#form_identification_keys').val(identification_keys.join(','));
    $('#form_most_searched').val($('#most-searched').val());
    $('#form_order').val($('#search-order').val());
    $('#form_search_query').val($('#search-query').val());
}

// form submit handling
$( ".capci-database form").on("submit", function(ev){
    fillInputs();
});

jQuery(document).ready(function($) {
    if (window.location.hash != null && window.location.hash !== '') {
        $('html,body').animate({scrollTop:$(window.location.hash).offset().top - 110}, 500);
    }
});
